@let performanceDefaults = performanceDefaultsInput();
@if (performanceDefaults) {
  <div class="content">
    <div class="section-header">
      <label class="header-label">Selection Defaults</label>
    </div>
    <div class="input-row">
      <label class="input-label">Altitude:</label>
      <input class="input-field" type="number" [(ngModel)]="performanceDefaults.altitude" (change)="valueChanged()"
        min="0" max="20000"/>
      <label class="units-label">Feet</label>
    </div>
    <div class="input-row">
      <label class="input-label">Fluid Type:</label>
      <select class="input-field" [(ngModel)]="performanceDefaults.fluidType" (ngModelChange)="valueChanged()">
        @for (fluidType of fluidTypes; track fluidType) {
          <option [value]="fluidType">{{ fluidType }}</option>
        }
      </select>
    </div>
    <div class="input-row">
      <label class="input-label">Antifreeze Concentration:</label>
      <input class="input-field" type="number" [(ngModel)]="performanceDefaults.antifreezeConcentration"
        (change)="valueChanged()" min="0" max="100"/>
      <label class="units-label">%</label>
    </div>
    <div class="input-row">
      <label class="input-label">Cooling Entering Dry Bulb:</label>
      <input class="input-field" type="number" [(ngModel)]="performanceDefaults.coolingDryBulbTemperature"
        (change)="valueChanged()"/>
      <label class="units-label">°F</label>
    </div>
    <div class="input-row">
      <label class="input-label">Cooling Entering Wet Bulb:</label>
      <input class="input-field" type="number" [(ngModel)]="performanceDefaults.coolingWetBulbTemperature"
        (change)="valueChanged()"/>
      <label class="units-label">°F</label>
    </div>
    <div class="input-row">
      <label class="input-label">Cooling Entering Fluid Temperature:</label>
      <input class="input-field" type="number" [(ngModel)]="performanceDefaults.coolingEnteringWaterTemperature"
        (change)="valueChanged()"/>
      <label class="units-label">°F</label>
    </div>
    <div class="input-row">
      <label class="input-label">Heating Entering Dry Bulb:</label>
      <input class="input-field" type="number" [(ngModel)]="performanceDefaults.heatingDryBulbTemperature"
        (change)="valueChanged()"/>
      <label class="units-label">°F</label>
    </div>
    <div class="input-row">
      <label class="input-label">Heating Entering Fluid Temperature:</label>
      <input class="input-field" type="number" [(ngModel)]="performanceDefaults.heatingEnteringWaterTemperature"
        (change)="valueChanged()"/>
      <label class="units-label">°F</label>
    </div>
    <div class="input-row">
      <label class="input-label">Minimum Equipment EER:</label>
      <input class="input-field" type="number" [(ngModel)]="performanceDefaults.minimumEquipmentEer"
        (change)="valueChanged()"/>
    </div>
    <div class="input-row">
      <label class="input-label">Desired Waterflow:</label>
      <input class="short-input-field" type="number" [(ngModel)]="performanceDefaults.desiredFluidFlow"
        (change)="valueChanged()"/>
      <label class="units-label">±</label>
      <input class="short-input-field" type="number" [(ngModel)]="performanceDefaults.desiredFluidFlowTolerance"
        (change)="valueChanged()"/>
      <label class="units-label">gpm/ton</label>
    </div>
    <div class="section-header">
      <label class="header-label">Selection Tolerances - Cooling</label>
    </div>
    <div class="field-header-row">
      <label class="input-label"></label>
      <label class="spacer-label"></label>
      <label class="units-label">below</label>
      <label class="spacer-label"></label>
      <label class="spacer-label"></label>
      <label class="units-label">above</label>
    </div>
    <div class="input-row">
      <label class="input-label">Actual Air Flow:</label>
      <input class="short-input-field" type="number" [(ngModel)]="performanceDefaults.coolingActualAirflowUnderTolerance"
        (change)="valueChanged()"/>
      <label class="units-label">-</label>
      <input class="short-input-field" type="number" [(ngModel)]="performanceDefaults.coolingActualAirflowOverTolerance"
        (change)="valueChanged()"/>
      <label class="units-label">%</label>
    </div>
    <div class="input-row">
      <label class="input-label">Total Capacity:</label>
      <input class="short-input-field" type="number" [(ngModel)]="performanceDefaults.coolingTotalCapacityUnderTolerance"
        (change)="valueChanged()"/>
      <label class="units-label">-</label>
      <input class="short-input-field" type="number" [(ngModel)]="performanceDefaults.coolingTotalCapacityOverTolerance"
        (change)="valueChanged()"/>
      <label class="units-label">%</label>
    </div>
    <div class="input-row">
      <label class="input-label">Sensible Capacity:</label>
      <input class="short-input-field" type="number" [(ngModel)]="performanceDefaults.sensibleCapacityUnderTolerance"
        (change)="valueChanged()"/>
      <label class="units-label">-</label>
      <input class="short-input-field" type="number" [(ngModel)]="performanceDefaults.sensibleCapacityOverTolerance"
        (change)="valueChanged()"/>
      <label class="units-label">%</label>
    </div>
    <div class="input-row">
      <label class="input-label">Leaving Air Dry Bulb:</label>
      <input class="short-input-field" type="number"
        [(ngModel)]="performanceDefaults.coolingLeavingAirDryBulbUnderTolerance" (change)="valueChanged()"/>
      <label class="units-label">-</label>
      <input class="short-input-field" type="number"
        [(ngModel)]="performanceDefaults.coolingLeavingAirDryBulbOverTolerance" (change)="valueChanged()"/>
      <label class="units-label">%</label>
    </div>
    <div class="section-header">
      <label class="header-label">Selection Tolerances - Heating</label>
    </div>
    <div class="field-header-row">
      <label class="input-label"></label>
      <label class="spacer-label"></label>
      <label class="units-label">below</label>
      <label class="spacer-label"></label>
      <label class="spacer-label"></label>
      <label class="units-label">above</label>
    </div>
    <div class="input-row">
      <label class="input-label">Actual Air Flow:</label>
      <input class="short-input-field" type="number" [(ngModel)]="performanceDefaults.heatingActualAirflowUnderTolerance"
        (change)="valueChanged()"/>
      <label class="units-label">-</label>
      <input class="short-input-field" type="number" [(ngModel)]="performanceDefaults.heatingActualAirflowOverTolerance"
        (change)="valueChanged()"/>
      <label class="units-label">%</label>
    </div>
    <div class="input-row">
      <label class="input-label">Total Capacity:</label>
      <input class="short-input-field" type="number" [(ngModel)]="performanceDefaults.heatingTotalCapacityUnderTolerance"
        (change)="valueChanged()"/>
      <label class="units-label">-</label>
      <input class="short-input-field" type="number" [(ngModel)]="performanceDefaults.heatingTotalCapacityOverTolerance"
        (change)="valueChanged()"/>
      <label class="units-label">%</label>
    </div>
  </div>
}
